import axios, { AxiosPromise, Canceler, CancelTokenStatic } from 'axios';
import { IEmployee } from '../../../@types/model/masterData/employee/employee';
import { IEmployeeUpsert } from '../../../@types/model/masterData/employee/employeeUpsert';

export default class EmployeeHttpService {
    private static readonly CancelToken : CancelTokenStatic = axios.CancelToken;
    /**
     * Allows you to cancel list request
     */
    public static cancelGetList ?: Canceler;

    public static getList(divisionIds : Array<number> | null) : AxiosPromise<Array<IEmployee>> {
        if (this.cancelGetList) {
            this.cancelGetList('GET Canceled');
            this.cancelGetList = undefined;
        }

        return axios.get(`${API_URL}/v1/MasterData/Employee/GetList`, {
            params: {
                divisionIds,
            },
            paramsSerializer: {
                indexes: null
            },
            cancelToken: new this.CancelToken((c) => {
                this.cancelGetList = c;
            }),
        });
    }

    public static upsert = (upsert : IEmployeeUpsert, type : 'Add' | 'Edit') : AxiosPromise<IEmployee> => {
        return axios.post(`${API_URL}/v1/MasterData/Employee/${type}`, upsert);
    }

    public static delete = (id : number) : AxiosPromise<IEmployee> => {
        return axios.delete(`${API_URL}/v1/MasterData/Employee/Delete`, {
            params: { id },
        });
    }
}